(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:jqSlider
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <jq-slider></jq-slider>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('jqSlider', jqSlider);

    function jqSlider($compile, $timeout) {
        return {
            restrict: 'AE',
            scope: {
                isDisabled: '=',
                ngModel: "="
            },
            replace: true,
            controllerAs: 'jqSlider',
            link: function (scope, element, attrs) {
                var slider = angular.element(element);
                var settings = {
                    labelClass: 'normal-label label-top-0',
                    step:10
                };
                scope.settings = null;
                if (angular.isDefined(attrs.jqSlider)){
                    scope.settings = angular.extend(settings,scope.$parent.$eval(attrs.jqSlider));
                }

                slider.css({
                    border: 0,
                    color: "#7d7d7d",
                    fontWeight: "bold",
                    display: "inline-block",
                    width: "unset"
                });
                slider.attr('readonly', true);
                slider.prop('readonly', true);

                var html = '<div class="clearfix"></div><div class="slider-range-max"></div>' +
                    '<labe class="{{settings.labelClass}} pull-left">' +
                    '<small>{{settings.min}}</small></labe>' +
                    '<labe class="{{settings.labelClass}} pull-right">' +
                    '<small>{{settings.max}}</small></labe><div class="clearfix"></div>';

                var htmlAngular = angular.element(html);
                slider.after(htmlAngular);
                $compile(htmlAngular)(scope);

                scope.$watch('ngModel', function(newVal, oldVal){
                    if(newVal!==oldVal){
                        $( ".slider-range-max" ).slider( "option", "value", newVal );
                    }
                });

                scope.$watch('isDisabled', function(newVal, oldVal){
                    if(newVal!==oldVal){
                        $( ".slider-range-max" ).slider( "option", "disabled", newVal );
                    }
                });

                $timeout(function() {
                    scope.$apply();
                    $( ".slider-range-max" ).slider({
                        range: "min",
                        value: scope.ngModel,
                        min: scope.settings.min,
                        max: scope.settings.max,
                        step: scope.settings.step,
                        slide: function( event, ui ) {
                            scope.$apply(function(){
                                slider.val( ui.value );
                                scope.ngModel = ui.value
                            });
                        }
                    });
                    slider.val( $( ".slider-range-max" ).slider( "value" ) );
                    if(scope.isDisabled){
                        slider.slider( "option", "disabled", true )
                    }
                },0);
            }
        }
    }
}());